import { Outlet } from "react-router-dom";
import Header from "../../../components/Header";
import Sidebar from "../../../components/Sidebar";
import { SidebarProvider, useSidebar } from "../../../context/SidebarContext";

const LayoutContent = () => {
  const { isOpen } = useSidebar();

  return (
    <div className={`d-flex app-body ${isOpen ? "open" : "closed"}`}>
      <Sidebar />
      <main>
        <Header />
        <div className="bdrtp"></div>
        <div className="extrpdng">
          <div
            className={`container-fluid  ${
              isOpen ? "" : "container-fluid"
            } mb-4`}
          >
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};

const Layout = () => {
  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default Layout;
